export default function getTextColor(intensity, theme) {
  switch (intensity) {
    case 100:
      return theme.palette.text.disabled;
    case 200:
      return theme.palette.text.secondary;
    case 300:
      return theme.palette.text.primary;
  }
}
